import Vue from 'vue';

// state
export const state = {
  planToEdit: null,
  planItemsToEdit: null,
};

export const mutations = {
  setPlanToEdit(state, plan) {
    state.planToEdit = plan;
  },
  setPlanItemsToEdit(state, plan) {
    state.planItemsToEdit = plan;
  },
};

export const actions = {};

export const getters = {
  workPlanToEdit: state => state.planToEdit,
  workPlanItemsToEdit: state => state.planItemsToEdit,
};
